type BorderLoaderProps = {
  className?: string;
  color?: string;
};

export const BorderLoaderLogo = ({
  className = "",
  color = "#FF5E00",
}: BorderLoaderProps) => {
  return (
    <svg
      className={`absolute -inset-0 w-full h-full scale-[1.03] origin-center ${className}`}
      viewBox="0 0 60 61"
      preserveAspectRatio="none"
    >
      <rect
        x="2"
        y="2"
        width="56"
        height="56"
        rx="15"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeDasharray="20 178"
        strokeLinecap="round"
        style={{ filter: "blur(1.5px)" }}
        className="border-loader-logo"
      />
      <rect
        x="2"
        y="2"
        width="56"
        height="56"
        rx="15"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeDasharray="20 178"
        strokeLinecap="round"
        className="border-loader-logo"
      />
    </svg>
  );
};